import { IdcardOutlined } from '@ant-design/icons';
import {
  GetFrontAnagraficheDelegatiParams,
  useGetFrontAnagraficheDelegati,
} from '@framework/api-client';
import { t } from '@framework/i18n';
import {
  Link,
  LoadingPageBody,
  ModalDialog,
  generatePath,
  getNetworkErrorMessage,
} from '@framework/ui';
import { Alert, Space } from 'antd';
import React, { useState } from 'react';
import { IAddressBookSelectInputOnSelect } from './AddressBookButton';
import { AddressBookModalTable } from './AddressBookModalTable';

export interface IAddressBookModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  idFieldName: string;
  onSelect: IAddressBookSelectInputOnSelect;
  selected?: string[];
}

/**
 * Modal con la lista dei delegati registrati in rubrica, selezionabili.
 */
export function AddressBookModal(props: IAddressBookModalProps) {
  const { isOpen, setIsOpen, idFieldName, onSelect } = props;

  const [query, setQuery] = useState<GetFrontAnagraficheDelegatiParams>({
    limite: 10,
    pagina: 0,
    ordinamenti: ['cognome'],
  });
  const { data, error, isLoading, isFetching } = useGetFrontAnagraficheDelegati(
    query,
    {
      query: {
        keepPreviousData: true,
      },
    },
  );

  const hasRecords = Boolean(data?.dati?.length);

  return (
    <ModalDialog
      open={isOpen}
      title={
        <Space>
          <IdcardOutlined aria-hidden />
          {t(
            'address-book.modal.title.seleziona-delegato',
            'Seleziona delegato',
          )}
        </Space>
      }
      onCancel={() => setIsOpen(false)}
      size="medium"
      destroyOnClose
      footer={null}
    >
      {(isLoading || isFetching) && !hasRecords && <LoadingPageBody />}
      {error && (
        <Alert
          type="error"
          message={getNetworkErrorMessage(
            error.message,
            t(
              'address-book.modal.error.errore-caricamento-rubrica',
              'Errore durante il carimaneto della rubrica',
            ),
          )}
          showIcon
        />
      )}
      {!hasRecords && !isLoading && !isFetching && !error && (
        <Alert
          type="info"
          message={t(
            'address-book.modal.empty-list.message.rubrica-vuota',
            'Rubrica vuota',
          )}
          showIcon
          description={
            <>
              {t(
                'address-book.modal.empty-list.description1.nessun-delegato-vai-alla',
                'Nessun delegato presente nella rubrica. Vai alla',
              )}{' '}
              <Link
                to={generatePath('/rubrica')}
                target="_blank"
                rel="noreferrer"
              >
                {t(
                  'address-book.modal.empty-list.description2.link.rubrica',
                  'Rubrica',
                )}
              </Link>{' '}
              {t(
                'address-book.modal.empty-list.description3.per-aggiungerne-di-nuovi',
                'per aggiungerne di nuovi.',
              )}
            </>
          }
        />
      )}
      {hasRecords && (
        <AddressBookModalTable
          query={query}
          setQuery={setQuery}
          data={data}
          isLoading={isLoading}
          isFetching={isFetching}
          onSelect={onSelect}
          setIsOpen={setIsOpen}
          selected={props.selected}
          idFieldName={idFieldName}
        />
      )}
    </ModalDialog>
  );
}
